import { render, staticRenderFns } from "./DocFilter.vue?vue&type=template&id=12cc5826"
import script from "./DocFilter.vue?vue&type=script&lang=js"
export * from "./DocFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports